<template>
  <div class="wwf-form" :class="[{ 'formValidation-shake' : isShake }]">
    <div class="wwf-loading-container" v-show="isLoading">
      <div class="wwf-loading">
        <span></span>
      </div>
    </div>

    <form-wizard
      ref="wizard"
      shape="tab"
      @on-loading="setLoading"
      :start-index.sync="stepIndex"
      :on-change="setFormStepState(stepIndex)"
    >
      <h2 slot="title"></h2>
      <tab-content title="Choose" :before-change="()=>validateStep('step1')">
        <Step1 ref="step1" />
      </tab-content>
      <tab-content title="Details" :before-change="()=>validateStep('step2')">
        <Step2 ref="step2" :disabledGoogleAutocomplete="disabledGoogleAutocomplete" />
      </tab-content>
      <tab-content title="Payment">
        <Step3 />
      </tab-content>
      <template slot="footer" slot-scope="props">
        <div class="form-buttons prev">
          <a
            href="#form-top"
            id="Previous"
            data-animation-duration="300"
            data-animation-easing="swing"
            data-smooth-scroll
            data-threshold="75"
            v-show="props.activeTabIndex == 1"
            @click="props.prevTab()"
            :style="props.fillButtonStyle"
          >Previous</a>
        </div>

        <div class="form-buttons next">
          <a
            href="#form-top"
            id="Next"
            :class="(props.activeTabIndex != 0 && donation.payementType == 'wwf_paypal') ? 'paypal-button' : ''"
            data-animation-duration="300"
            data-animation-easing="swing"
            @click="props.nextTab()"
            data-smooth-scroll
            data-threshold="75"
            v-show="props.activeTabIndex != 2"
            :style="props.fillButtonStyle"
          >{{ (props.activeTabIndex == 0) ? 'Next' : ((donation.payementType == 'wwf_paypal') ? 'Pay with PayPal' : 'Go to payment')}}</a>
        </div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

import {
  getParameterByName,
  getNameByDonatiuonType,
  pushDatalayerDetail
} from "../../helpers";

import { mapState } from "vuex";

export default {
  name: "FormProduct",
  components: {
    Step1, // Donation details (packages, handle, donation type, email, payement type)
    Step2, // Personnal details (name, address)
    Step3 // Payment
  },
  data() {
    return {
      isShake: false,
      isLoading: false,
      stepIndex: 0
    };
  },
  computed: mapState({
    donation: state => state.donation.donation,
    product: state => state.product.product
  }),
  props: {
    productId: {
      // Attribute for the productID
      type: String,
      required: true
    },
    productVersion: {
      // Attribute for the version of the product
      type: String
    },
    disabledGoogleAutocomplete: {
      // Attribute for the version of the product
      type: Boolean,
      default: false
    }
  },
  created: async function() {
    this.setLoading(true);

    // Check if there payment paypal pending to excecute
    let paymentid = getParameterByName("paymentId");
    let payerid = getParameterByName("PayerID");
    if (payerid && paymentid) {
      console.log("excecutePayment found");
      const excecutePayment = await this.$store.dispatch("excecutePayment", {
        payerid: payerid,
        paymentid: paymentid
      });

      if (excecutePayment) {
        window.app.thankyou(
          excecutePayment.amount,
          excecutePayment.type,
          excecutePayment.id,
          excecutePayment.productname,
          excecutePayment.postcode,
          excecutePayment.firstname,
          excecutePayment.lastname,
          excecutePayment.producttype,
          excecutePayment.certificateurl,
          excecutePayment.productid,
          "wwf_paypal",
          excecutePayment.wilcardpdf
        );
      }
    }

    // Get product data (+ packages details)
    await this.$store.dispatch("getProductById", {
      id: this.productId,
      source: window.location.href,
      appealid: getParameterByName("t"),
      fundid: getParameterByName("f")
    });

    // Check if there are some query string in URL to prefill the form, Query from donate widget
    let q = getParameterByName("q");
    if (q) {
      let decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      let amount = getParameterByName("amount", decodeq);
      let dollarhandle = getParameterByName("dollarhandle", decodeq);
      let email = getParameterByName("email", decodeq);

      console.log("amount", amount);
      console.log("dollarhandle", dollarhandle);
      console.log("email", email);

      this.donation.dollarhandle = dollarhandle;
      this.donation.amount = amount;
      this.donation.email = email;
    }

    // Pre-select the doallar handle and the package (rule: first item on the list)
    // As we only have Single and Regular, always set Single as the first option
    const defaultType = this.product.appealcodesetting.defaultdonationtype;    
    this.product.donationtypes = this.product.donationtypes.sort((a, b) => {
      if (a === defaultType) {
        return -1;
      }
      if (b === defaultType) {
        return 1;
      }
      return 0;
    }); // Reverse alphabetical order

    this.donation.type = defaultType;
    const settings = this.product.donationsettings[defaultType];
    if (settings) {
      this.donation.campaignid = settings.campaignid;
      this.donation.fundid = settings.fundid;
    }

    if (this.product.producttype != "wildcard") {
      // Pre-select the package (rule: first item on the list)
      this.donation.packagecode =
        this.product.packages && this.product.packages.length > 0
          ? this.product.packages[0]
          : null;

      await this.$store.dispatch("getAllPackagesForProduct");
    }

    // GTM: Push datalayer add to cart
    pushDatalayerDetail(
      this.product.productname,
      this.product.id,
      this.product.producttype,
      getNameByDonatiuonType(this.donation.type)
    );

    this.setLoading(false);
  },
  methods: {
    // Todo: Keep the greater step
    setFormStepState: function(step) {
      this.donation.formWizardCurrentStep = step;
    },
    setLoading: function(value) {
      this.isLoading = value;
    },
    validateStep: function(name) {
      return new Promise((resolve, reject) => {
        var refToValidate = this.$refs[name];
        var isValid = refToValidate.validate().then(
          function(response) {
            resolve(true);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    reset: function() {
      //TDOD this.$refs.wizard.reset????
      this.$refs.wizard.changeTab(2, 0);
      this.$store.dispatch("resetDonation");

      // Pre-select the doallar handle and the package (rule: first item on the list)
      this.donation.type =
        this.product.donationtypes && this.product.donationtypes.length > 0
          ? this.product.donationtypes[0]
          : null;

      const settings = this.product.donationsettings[this.donation.type];
      if (settings) {
        this.donation.campaignid = settings.campaignid;
        this.donation.fundid = settings.fundid;
      }

      this.donation.packagecode =
        this.product.packages && this.product.packages.length > 0
          ? this.product.packages[0]
          : null;

      console.log("reset");
    },
    retry: function() {
      this.setLoading(true);
      this.$store.dispatch("retryDonation").then(
        response => {
          this.$store.dispatch("checkout").then(result => {
            this.$refs.wizard.activateAll();
            this.setLoading(false);
          });
        },
        error => {
          console.error("saveDonation error", error);
        }
      );
      console.log("retry");
    },
    disablesteps: function() {
      this.$refs.wizard.desActivateAll();
    }
  }
};
</script>






// WEBPACK FOOTER //
// FormProduct.vue?7718caab